import './LoadingSpinner.scss';

/**
 * The app's spinner.
 *
 * `small` is for one inside a panel rather than one holding a page.
 * The full size is 120px across with a 16px rim, which is right when
 * it is the only thing on screen and absurd when it sits above two
 * lines of text in a step - it filled the panel and read as something
 * having gone wrong.
 */
export const LoadingSpinner = ({ small }: { small?: boolean } = {}) => {
  return <div className={small ? 'loader loader--small' : 'loader'}></div>;
};
